module.exports = __webpack_public_path__ + "img/email.d5775d0e.png";